import React from 'react';

import * as ROUTES from './Constants/routes';

import { Route, Switch } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import './App.css';
import { Helmet } from 'react-helmet';
 
import Home from './Home';
import SupportUs from './SupportUs';
import Error from './Error';
import Navigation from './Navigation';
import Footer from './Footer';
import About from './About';
import Schedule from './Schedule';

library.add(fab);

const seo = {
  title: "Envato Houston",
  description:
    "The official website of the COVID-19 relief organization Envato.",
  url: "https://envato-houston-2021.netlify.app/",
  image: "https://envato-houston-2021.netlify.app/favicon.ico",
};

class App extends React.Component {
  render() {
      return (
        <div className="containerMain">
          <Helmet
            title={seo.title}
            meta={[
              {
                name: "description",
                property: "og:description",
                content: seo.description,
              },
              { property: "og:title", content: seo.title },
              { property: "og:url", content: seo.url },
              { property: "og:image", content: seo.image },
              { property: "og:image:type", content: "image/png" },
              { property: "twitter:image:src", content: seo.image },
              { property: "twitter:title", content: seo.title },
              { property: "twitter:description", content: seo.description },
            ]}
          />
          <Navigation />
          <div className="offset">
            <Switch>
              <Route exact path={ROUTES.CUSTOM_HOME} render={(_) => <Home />} />
              <Route exact path={ROUTES.HOME} render={(_) => <Home />} />
              <Route exact path={ROUTES.ABOUT} render={(_) => <About />} />
              <Route exact path={ROUTES.SUPPORTUS} render={(_) => <SupportUs />} />
              <Route exact path={ROUTES.SCHEDULE} render={(_) => <Schedule />} />
              <Route render={(_) => <Error />} />
            </Switch>
          </div>
          <Footer />
        </div>
      ); 
    
  }
}

export default App;
